"use strict";
/**
 * Firebase Storage Constants
 *
 * Path patterns for Firebase Storage uploads.
 * These must match the Firebase Storage security rules.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.STORAGE_ERRORS = exports.STORAGE_PATHS = exports.STORAGE_USERS_FOLDER = void 0;
// Base folder for user-specific uploads (matches storage rules: /users/{userId}/...)
exports.STORAGE_USERS_FOLDER = "users";
// Storage path builder functions
exports.STORAGE_PATHS = {
    /**
     * Build path for user document uploads
     * @param userId - Firebase Auth UID
     * @param fileName - Name of the file being uploaded
     * @returns Full storage path: users/{userId}/{fileName}
     */
    userDocument: function (userId, fileName) {
        return "".concat(exports.STORAGE_USERS_FOLDER, "/").concat(userId, "/").concat(fileName);
    },
};
// User-facing error messages for storage operations
exports.STORAGE_ERRORS = {
    USER_NOT_AUTHENTICATED: "User not authenticated. Please log in to upload documents.",
};
